enum CRM_ACTION_TYPES {
  BENEF_SEARCH = 'BENEF_SEARCH',
  HIS_BENEF_SEARCH = 'HIS_BENEF_SEARCH',
  SET_SELECTED_TAB = 'SET_SELECTED_TAB',
  SET_ADMISSION_FORM_VAL = 'SET_ADMISSION_FORM_VAL',
  SET_ADDITIONAL_ADMISSION_INFO = 'SET_ADDITIONAL_ADMISSION_INFO',
  SET_IS_SHOW_ADMISSION_FORM = 'SET_IS_SHOW_ADMISSION_FORM',
  SET_SELECTED_INSURER_ID = 'SET_SELECTED_INSURER_ID',
  SET_CORPORATE_NAME = 'SET_CORPORATE_NAME',
  SET_BENEFICIARY_LIST = 'SET_BENEFICIARY_LIST',
  SET_BENEFICIARY_REQUEST_OBJECT = 'SET_BENEFICIARY_REQUEST_OBJECT',
  SET_BENEFICIARY_POPUP_FLAG = 'SET_BENEFICIARY_POPUP_FLAG',
  CLEAR_STATE = 'CLEAR_STATE',
  SELECT_BENEFICIARY = 'SELECT_BENEFICIARY',
  SELECT_CLAIMDETAIL_BACKUP = 'SELECT_CLAIMDETAIL_BACKUP',
  SELECTED_BENEFICIARY_STATUS = 'SELECTED_BENEFICIARY_STATUS',
  UPLOAD_FILES = 'UPLOAD_FILES',
  MAX_FILE_SIZE_ALLOWED = 'MAX_FILE_SIZE_ALLOWED',
  TOGGLE_CLICK= 'TOGGLE_CLICK',
  SET_FILE_DIALOG_OPEN= 'SET_FILE_DIALOG_OPEN',
  LINK_ABHA_CLICK = 'LINK_ABHA_CLICK',
  MOBILE_VERIFICATION = 'MOBILE_VERIFICATION',
  HEALTH_VAULT_ENABLE = 'HEALTH_VAULT_ENABLE',
  HEALTH_VAULT_DOCUMENT_UPLOAD = 'HEALTH_VAULT_DOCUMENT_UPLOAD',
  ENABLE_AADHAR = 'ENABLE_AADHAR',
  SET_USER_PRESENT = 'SET_USER_PRESENT',
  SET_USERS_NOT_FOUND = 'SET_USER_NOT_FOUND',
  SET_CHECK_ALL = 'SET_CHECK_ALL',
  MOBILE_ON_SCREEN = 'MOBILE_ON_SCREEN',
  ENABLE_MOBILE_OTP = 'ENABLE_MOBILE_OTP',
  ENABLE_AADHAAR_OTP = 'ENABLE_AADHAAR_OTP',
  SET_AADHAR_VERIFICATION_SUCCESS = 'SET_AADHAR_VERIFICATION_SUCCESS',
  ENCRYPTED_NO_VALUE = 'ENCRYPTED_NO_VALUE',
  TXN_ID = 'TXN_ID',
  HOSP_ACTION_ID = 'HOSP_ACTION_ID',
  DOA_VALUE = 'DOA_VALUE',
  MOBILE_OTP = 'MOBILE_OTP',
  AADHAAR_OTP = 'AADHAAR_OTP',
  MOBILE_NO_VALUE = 'MOBILE_NO_VALUE',
  TEMP_PROFILE = 'TEMP_PROFILE',
  AADHAR_NO_VALUE = 'AADHAR_NO_VALUE',
  SUBMIT_ADMISSION = 'SUBMIT_ADMISSION',
  DOWNLOAD_CLAIM_PDF = 'DOWNLOAD_CLAIM_PDF',
  PRINT_CLAIM_PDF = 'PRINT_CLAIM_PDF',
  HIS_PRINT_CLAIM_PDF = 'HIS_PRINT_CLAIM_PDF',
  IS_MINIMIZE = 'IS_MINIMIZE',
  IS_SHOW_OTHER_MINIMIZE = 'IS_SHOW_OTHER_MINIMIZE',
  SET_SELECTED_DISCREPENCY = 'SET_SELECTED_DISCREPENCY',
  SET_NON_SELECTED_DISCREPENCY = 'SET_NON_SELECTED_DISCREPENCY',
  SET_PROBABILITY = 'SET_PROBABILITY',
  SET_BUDDHIMED_SELECTED_FILES = 'SET_BUDDHIMED_SELECTED_FILES',
  SET_PREVIOUSLY_UPLOADED_FILES = 'SET_PREVIOUSLY_UPLOADED_FILES',
  IS_MODAL = 'IS_MODAL',
  UPDATE_DRAFT_VALUE = 'UPDATE_DRAFT_VALUE',
  SET_CLASSIFICATION_ARRAY = 'SET_CLASSIFICATION_ARRAY',
  SET_USER_PROFILES = 'SET_USER_PROFILES',
  SET_UPLOADED_FILE_NAMES = 'SET_UPLOADED_FILE_NAMES',
  SET_UPLOADED_FILE_GUID = 'SET_UPLOADED_FILE_GUID',
  SET_UPLOADED_FILE_TYPES = 'SET_UPLOADED_FILE_TYPES',
  SET_UPLOADED_FILE_LIST = 'SET_UPLOADED_FILE_LIST',
  SET_CHECKED_FILE_LIST = 'SET_CHECKED_FILE_LIST',
  SET_BILLAMOUNT_ARRAY = 'SET_BILLAMOUNT_ARRAY',
  IS_FILE_PROCESS_IN_PROGRESS = 'IS_FILE_PROCESS_IN_PROGRESS',
  NON_AVAILABLE_CLASSIFICATION = 'NON_AVAILABLE_CLASSIFICATION',
  SET_PERCENT = 'SET_PERCENT',
  GO_TO_NEXT = 'GO_TO_NEXT',
  CLICKED_ON_SKIP = 'CLICKED_ON_SKIP',
  IS_COME_FROM_SUBMIT = 'IS_COME_FROM_SUBMIT',
  SET_IS_SUBMIT_CLICKED = 'SET_IS_SUBMIT_CLICKED',
  SET_IS_SUCCESS_MODAL_NEW_ADMISSION = 'SET_IS_SUCCESS_MODAL_NEW_ADMISSION',
  SET_SUBMIT_WITHOUT_DOCS_CLICKED = 'SET_SUBMIT_WITHOUT_DOCS_CLICKED',
  UPDATE_SELECTED_CENTER = 'UPDATE_SELECTED_CENTER',
  UPDATE_PACKAGE_SELECTION = 'UPDATE_PACKAGE_SELECTION',
  SET_EXTRA_FORM_VALUES = 'SET_EXTRA_FORM_VALUES',
  SET_CARD_COLLAPSE = 'SET_CARD_COLLAPSE',
  CLEAR_SELECTED_PACKAGE = 'CLEAR_SELECTED_PACKAGE',
  SUBMIT_IR = 'SUBMIT_IR',
  CANCEL_CLAIM = 'CANCEL_CLAIM',
  IS_LOADING_PRE_DATA = 'IS_LOADING_PRE_DATA',
  SUBMIT_SETTLEMENT = 'SUBMIT_SETTLEMENT',
  SUBMIT_SETTLEMENT_COURIER = 'SUBMIT_SETTLEMENT_COURIER',
  MANUAL_SUBMISSION = 'MANUAL_SUBMISSION',
  UPDATE_MEMBER_NAME = 'UPDATE_MEMBER_NAME',
  SET_IS_ABHA_ID_VERIFIED = 'SET_IS_ABHA_ID_VERIFIED',
  MODAl_FORM_VALUES = 'MODAl_FORM_VALUES',
  SET_IS_DRAFT_SELECTED = 'SET_IS_DRAFT_SELECTED',
  SET_SELECTED_DRAFT = 'SET_SELECTED_DRAFT',
  SET_HOSPITAL_WISE_PAYER_LIST = 'SET_HOSPITAL_WISE_PAYER_LIST',
  SET_IS_COMPONENT_RENDERED = 'SET_IS_COMPONENT_RENDERED',
  SET_EXISTING_CLAIM_ERROR = 'SET_EXISTING_CLAIM_ERROR',
  SET_NEW_ADMISSION_SEARCH_VAL = 'SET_NEW_ADMISSION_SEARCH_VAL',
  SET_HEALTH_CARD_TYPE = 'SET_HEALTH_CARD_TYPE',
  CHECK_DUPLICATE_CLAIM = 'CHECK_DUPLICATE_CLAIM',
  GET_HEALTH_ID_CARD = 'GET_HEALTH_ID_CARD',
  SET_IS_DISCHARGE_CASE = 'SET_IS_DISCHARGE_CASE',
  SET_IS_COVID_CASE = 'SET_IS_COVID_CASE',
  DELAYED_ADMISSION = 'DELAYED_ADMISSION',
  LOSgt90 = 'LOSgt90',
  UPDATE_DEFAULT_TIMELINE = 'UPDATE_DEFAULT_TIMELINE',
  DOWNLOAD_DOCUMENTS_GUIDS = 'DOWNLOAD_DOCUMENTS_GUIDS',
  UPDATE_ADDITIONAL_MANDATORY_DOCS = 'UPDATE_ADDITIONAL_MANDATORY_DOCS',
  UPDATE_AUTOMATED_PROCEDURE_OPTIONS = 'UPDATE_AUTOMATED_PROCEDURE_OPTIONS',
  TOGGLE_OTHER_PROCEDURE = 'TOGGLE_OTHER_PROCEDURE',
  TOGGLE_OTHER_ROOM_TYPE = 'TOGGLE_OTHER_ROOM_TYPE',
  SET_HOSP_DETAILS_FOR_ROOM_TYPE = 'SET_HOSP_DETAILS_FOR_ROOM_TYPE',
  HOSPITAL_OTHER_ROOM_TYPE = 'HOSPITAL_OTHER_ROOM_TYPE',
  SET_STATUS_NAME = 'SET_STATUS_NAME',
  HID_CONFIRMATION = 'HID_CONFIRMATION',
  FETCH_ABHA_VERIFICATION_METHODS = 'FETCH_ABHA_VERIFICATION_METHODS',
  FETCH_ABHA_VERIFICATION_METHODS_SUCCESS = 'FETCH_ABHA_VERIFICATION_METHODS_SUCCESS',
  FETCH_ABHA_VERIFICATION_METHODS_FAILURE = 'FETCH_ABHA_VERIFICATION_METHODS_FAILURE',
  ABHA_VERIFICATION_SENT_OTP = 'ABHA_VERIFICATION_SENT_OTP',
  ABHA_VERIFICATION_SENT_OTP_SUCCESS = 'ABHA_VERIFICATION_SENT_OTP_SUCCESS',
  ABHA_VERIFICATION_SENT_OTP_FAILURE = 'ABHA_VERIFICATION_SENT_OTP_FAILURE',
  ABHA_CONFIRM_OTP = 'ABHA_CONFIRM_OTP',
  ABHA_CONFIRM_OTP_SUCCESS = 'ABHA_CONFIRM_OTP_SUCCESS',
  ABHA_CONFIRM_OTP_ERROR = 'ABHA_CONFIRM_OTP_ERROR',
  CREATE_ABHA_ALREADY_EXIST = 'CREATE_ABHA_ALREADY_EXIST',
  SET_FORM_ACTION = 'SET_FORM_ACTION',
  UPDATE_BILL_DETAILS = 'UPDATE_BILL_DETAILS',
  UPDATE_ADMISSION_START_TIME = 'UPDATE_ADMISSION_START_TIME',
  CHANGE_FORM_TYPE = 'CHANGE_FORM_TYPE',
  TOGGLE_ENABLE_FILE_UPLOAD_FORCE = 'TOGGLE_ENABLE_FILE_UPLOAD_FORCE',
  RESET_DETAIL_NAV = 'RESET_DETAIL_NAV',
  SET_SELECTED_SEARCH_TYPE = 'SET_SELECTED_SEARCH_TYPE',
  TOGGLE_CSV_MISMATCH = 'TOGGLE_CSV_MISMATCH',
  CSV_RETRY = 'CSV_RETRY',
  GET_OLD_CLAIM_DETAIL = 'GET_OLD_CLAIM_DETAIL',
  SET_SETTLEMENT_TYPE = 'SET_SETTLEMENT_TYPE',
  SET_AUTO_POPULATE_DAY_CARE_TOGGLE = 'SET_AUTO_POPULATE_DAY_CARE_TOGGLE',
  DISABLE_ROOM_TYPE = 'DISABLE_ROOM_TYPE',
  GET_AADHAR_OTP = 'GET_AADHAR_OTP',
  VERIFY_AADHAR_OTP = 'VERIFY_AADHAR_OTP',
  PAN_VERIFICATION = 'PAN_VERIFICATION',
  SET_ADHAAR_LOADING = 'SET_ADHAAR_LOADING',
  OTP_MODAL_VISIBLE = 'OTP_MODAL_VISIBLE',
  SET_SELECTED_OPTION = 'SET_SELECTED_OPTION',
  SET_SUCCESS_MODAL = 'SET_SUCCESS_MODAL',
  SET_ADHAAR_VERIFIED = 'SET_ADHAAR_VERIFIED',
  SET_PAN_VERIFIED = 'SET_PAN_VERIFIED',
  SET_PAN_NO_VERIFIED = 'SET_PAN_NO_VERIFIED',
  SET_PAGE_CHANGE_ALLOWED = 'SET_PAGE_CHANGE_ALLOWED',
  SET_DYNAMIC_QUESTION_FIELDS = 'SET_DYNAMIC_QUESTION_FIELDS',
  SET_AUTOMATED_PROCEDURE_ID = 'SET_AUTOMATED_PROCEDURE_ID',
  SET_PLT_ID = 'SET_PLT_ID',
  SET_SPECIALITY_OPTIONS = 'SET_SPECIALITY_OPTIONS',
  SET_PAN_NUMBER = 'SET_PAN_NUMBER',
  SET_PAN_REQUIRED = 'SET_PAN_REQUIRED',
  IS_PLT_CHANGED = 'IS_PLT_CHANGED',
  PLT_MAPPED_VALUE = 'PLT_MAPPED_VALUE',
  SET_NAME_ADHAAR_VERIFIED = 'SET_NAME_ADHAAR_VERIFIED',
  SET_AADHAAR_RESPONSE = 'SET_AADHAAR_RESPONSE',
  SET_AILMENT_VALUE= 'SET_AILMENT_VALUE',
  SET_PAYER_ROOM_TYPE = 'SET_PAYER_ROOM_TYPE',
  SET_NEW_BILL_DETAIL_VAL = 'SET_NEW_BILL_DETAIL_VAL',
  ENABLE_IPNUMBER_POPUP = 'ENABLE_IPNUMBER_POPUP',
  CREATE_HEALTHBANK_USER = 'CREATE_HEALTHBANK_USER',
  SHOW_SHARE_DOCUMENT_OPTIONS_MODAL = 'SHOW_SHARE_DOCUMENT_OPTIONS_MODAL',
  SET_NEW_HEALTHBANK_USER = 'SET_NEW_HEALTHBANK_USER',
  FETCH_HEALTHBANK_USER_PROFILE_DETAILS = 'FETCH_HEALTHBANK_USER_PROFILE_DETAILS',
  SET_SHOW_ABHA_LINK_MODAL = 'SET_SHOW_ABHA_LINK_MODAL',
  SET_HEALTHBANK_USER_SIGNUP_OPTION= 'SET_HEALTHBANK_USER_SIGNUP_OPTION',
  SET_DOCUMENT_UPLOAD_SUCCESS = 'SET_DOCUMENT_UPLOAD_SUCCESS',
  SET_SUBMIT_DISABLED = 'SET_SUBMIT_DISABLED',
  SET_MODAL_SWITCH = 'SET_MODAL_SWITCH',
  SET_DOB_LOADING = 'SET_DOB_LOADING',
  VOTER_ID_VERIFICATION = 'VOTER_ID_VERIFICATION',
  DRIVING_LICENSE_VERIFICATION = 'DRIVING_LICENSE_VERIFICATION',
  DOB_MODAL_VISIBLE = 'DOB_MODAL_VISIBLE',
  SET_DL_VERIFIED = 'SET_DL_VERIFIED',
  SET_VOTERID_VERIFIED = 'SET_VOTERID_VERIFIED',
  SET_PAN_VERIFICATION_REQUIRED = 'SET_PAN_VERIFICATION_REQUIRED',
  SET_DRAFT_FORM_VALIDATED = 'SET_DRAFT_FORM_VALIDATED',
  SET_SHOW_ACCIDENT_CARD= 'SET_SHOW_ACCIDENT_CARD',
  SET_CONDITION_ON_DISCHARGE = 'SET_CONDITION_ON_DISCHARGE',
  SET_HOURS_DIFFERENCE = 'SET_HOURS_DIFFERENCE',
  SET_DATE_APPLIED = 'SET_DATE_APPLIED',
  SET_SELECTED_AILMENT_VALUES = 'SET_SELECTED_AILMENT_VALUES',
  SET_MAPPED_AILMENT_VALUES = 'SET_MAPPED_AILMENT_VALUES',
  SET_IS_DOA_DOD_ENHANCEMENT_MODAL_OPEN = 'SET_IS_DOA_DOD_ENHANCEMENT_MODAL_OPEN',
  SET_NEW_BORN_CASE = 'SET_NEW_BORN_CASE',
  SET_MEMBER_SEARCH_ID = 'SET_MEMBER_SEARCH_ID',
  SET_SELECTED_MEMBER_CARD = 'SET_SELECTED_MEMBER_CARD',
  SET_MEMBER_ID = 'SET_MEMBER_ID',
  SET_BENEFICIARY_SEARCH_RESPONSE_PAYER_ID = 'SET_BENEFICIARY_SEARCH_RESPONSE_PAYER_ID',
  SET_BENEFICIARY_SEARCH_RESPONSE_PAYER_NAME = 'SET_BENEFICIARY_SEARCH_RESPONSE_PAYER_NAME',
  SET_SHOW_PAYER_NOT_CONFIGURED_MSG = 'SET_SHOW_PAYER_NOT_CONFIGURED_MSG',
  SET_SHOW_PAYER_UPDATED_MSG = 'SET_SHOW_PAYER_UPDATED_MSG',
  SET_SHOW_BENEFICIARY_CARD = 'SET_SHOW_BENEFICIARY_CARD',
  SET_PERCENTAGE_NAME_MATCH = 'SET_PERCENTAGE_NAME_MATCH',
  SET_IS_DEATH_CASE = 'SET_IS_DEATH_CASE',
  SET_DIAGNOSIS_FROM_PAYER_LOOKUP = 'SET_DIAGNOSIS_FROM_PAYER_LOOKUP',
  SET_PROCEDURE_FROM_PAYER_LOOKUP = 'SET_PROCEDURE_FROM_PAYER_LOOKUP',
  SET_GOVT_SCHEME_URN = 'SET_GOVT_SCHEME_URN',
  PAYMENT_ACKNOWLEDGE = 'PAYMENT_ACKNOWLEDGE',
  SET_DEFAULT_CLAIM = 'SET_DEFAULT_CLAIM',
  UPLOAD_TICKER_CONFIGURATOR = 'UPLOAD_TICKER_CONFIGURATOR',
  SAVE_TICKER_DATA = 'SAVE_TICKER_DATA',
  FINALDOCS = 'FINALDOCS',
  GET_APPLICATION_CONFIGURATION = 'GET_APPLICATION_CONFIGURATION',
  UPDATE_APPLICATION_CONFIGURATION = 'UPDATE_APPLICATION_CONFIGURATION',
  SET_HIS_SELECTED_FILES = 'SET_HIS_SELECTED_FILES',
  SET_HIS_CHECKED_FILES = 'SET_HIS_CHECKED_FILES',
  SET_UPDATED_LETTERS = 'SET_UPDATED_LETTERS',
  SUBMIT_HIS_FILE = 'SUBMIT_HIS_FILE',
  SET_FILES = 'SET_FILES',
  SET_HIS_FILE_SIZE = 'SET_HIS_FILE_SIZE',
  MERGE_DEMERGE_CLAIMS = 'MERGE_DEMERGE_CLAIMS',
  SET_DAYCARE_CASE = 'SET_DAYCARE_CASE',
  PAYER_DOCUMENTS = 'PAYER_DOCUMENTS',
  SET_SELECTED_DOCTOR_LIST = 'SET_SELECTED_DOCTOR_LIST',
  SET_PATIENT_SIGNATURE = 'SET_PATIENT_SIGNATURE',
  SET_ALLOW_NEXT_STAGE = 'SET_ALLOW_NEXT_STAGE',
  SET_STAR_DISABLED_BENEF_MESSAGE = 'SET_STAR_DISABLED_BENEF_MESSAGE',
  SET_SUBMIT_BTN_FROM_MODAL = 'SET_SUBMIT_BTN_FROM_MODAL',
  SET_HYPHENATED_GROUP = 'SET_HYPHENATED_GROUP',
  PATIENT_CONSENT_PROCEED_CLICKED = 'PATIENT_CONSENT_PROCEED_CLICKED',
  SET_SELECTED_CONSENT_OPTION = 'SET_SELECTED_CONSENT_OPTION',
  SET_SELECTED_CONSENT_OPTION_STYLE = 'SET_SELECTED_CONSENT_OPTION_STYLE',
  SET_CONSENT_DATE_TIME = 'SET_CONSENT_DATE_TIME',
  SET_IS_ARTEMIS = 'SET_IS_ARTEMIS',
}

export default CRM_ACTION_TYPES;
